// extracted by mini-css-extract-plugin
export default {"heading":"HeadingWithIcon__heading-FW0Q","description":"HeadingWithIcon__description-npqP","component":"HeadingWithIcon__component-T3fp","content":"HeadingWithIcon__content-SxlB"};